<template>
	<div class="pageWrapper">
		<el-row>
			<el-col :span="10">
				<div class="panel actionPanel">
					<img class="logo" src="../assets/primaryLogo.svg" />
					<div class="createOrganisationForm">
						<h1 style="font-weight: bold">Create An Organisation</h1>
						<p>Please enter your details to create an organisation.</p>
						<el-divider></el-divider>
						<el-alert
							v-if="creationSuccess"
							:closable="false"
							style="margin-bottom: 12px"
							title="Success"
							description="New organisation successfully created"
							type="success"
							show-icon
						>
						</el-alert>
						<el-alert
							v-if="creationError"
							:closable="false"
							style="margin-bottom: 12px"
							title="Unable to create organisation"
							:description="errorMessage"
							type="error"
							show-icon
						>
						</el-alert>
						<el-form
							ref="form"
							@keyup.native.enter="createOrg"
							:rules="formRules"
							label-position="top"
							label-width="100px"
							:model="createOrganisationForm"
						>
							<el-form-item prop="organisationName" label="Organisation Name">
								<el-input
									placeholder="ACME"
									v-model="createOrganisationForm.organisationName"
								></el-input>
							</el-form-item>
							<el-form-item prop="organisationAdminEmail" label="Organisation Admin Email">
								<el-input
									placeholder="admin@acme.com"
									v-model="createOrganisationForm.organisationAdminEmail"
								></el-input>
							</el-form-item>
							<el-form-item prop="adminSecretKey" label="Admin Secret Key">
								<el-input
									type="password"
									placeholder="Secret key"
									v-model="createOrganisationForm.adminSecretKey"
								></el-input>
							</el-form-item>
							<!-- <el-button
								@click="
									createOrganisationForm.usageStrategy
										? (createOrganisationForm.usageStrategy = null)
										: (createOrganisationForm.usageStrategy = 'executions')
								"
								type="text"
							>
								{{
									!createOrganisationForm.usageStrategy
										? "Specify a usage strategy for the organisation"
										: "Forgo a usage strategy for the organisation"
								}}
							</el-button> -->
							<el-checkbox
								v-model="enableUsageStrategy"
								style="margin: 10px 0"
							>
								Specify a usage strategy for the organisation
							</el-checkbox>
							<el-form-item
								v-if="enableUsageStrategy"
								prop="usageStrategy"
								label="Usage Strategy"
							>
								<el-radio-group v-model="createOrganisationForm.usageStrategy">
									<el-radio-button label="executions"></el-radio-button>
									<el-radio-button label="workflows"></el-radio-button>
									<el-radio-button label="executions&Workflows"></el-radio-button>
								</el-radio-group>
								<p
									style="
										font-size: 10px;
										word-break: break-word;
										margin: 0px;
										line-height: 20px;
										margin-top: 5px;
									"
								>
									About strategy:
									{{
										createOrganisationForm.usageStrategy === "executions"
											? "Usage is restricted to an available balance of workflow executions across the organisation"
											: createOrganisationForm.usageStrategy === "executions&Workflows"
											? "Usage is restricted to a balance of workflow executions and a fixed number of workflows across the organisation"
											: "Usage is restricted to a fixed number of workflows allowed across the organisation"
									}}
								</p>
							</el-form-item>
							<el-form-item>
								<el-button
									:disabled="
										!createOrganisationForm.organisationName ||
										!createOrganisationForm.adminSecretKey
											? true
											: false
									"
									:loading="operationInProgress"
									@click="createOrg"
									style="width: 100%; margin-top: 12px"
									type="primary"
									>Create Organisation</el-button
								>
							</el-form-item>
							<el-form-item>
								<div style="text-align: center">
									Don't have an account?
									<el-button @click="$router.push('/signup')" style="position: relative" type="text"
										>Sign up now <img class="underline" src="../assets/underline.svg"
									/></el-button>
								</div>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
			<el-col :span="14">
				<div class="panel contentPanel"><mediaCarousel /></div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import mediaCarousel from "../components/mediaCarousel.vue";
import { httpHelper } from "../utils/httpHelper.js";
let $this;
export default {
	components: {
		mediaCarousel,
	},
	data() {
		const validateEmail = function (rule, value, callback) {
			var re =
				/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!re.test(String(value).toLowerCase())) {
				callback(new Error("Please enter a valid email"));
				$this.emailIsValid = false;
			} else {
				callback();
				$this.emailIsValid = true;
			}
		};
		return {
			usageStrategy: null,
			errorMessage: "An unknown error occurred",
			creationSuccess: false,
			creationError: false,
			operationInProgress: false,
			enableUsageStrategy: false,
			createOrganisationForm: {
				organisationName: "",
				adminSecretKey: "",
				organisationAdminEmail: "",
				usageStrategy: null,
			},
			formRules: {
				organisationName: [{ required: true, message: "An organisation name is required", trigger: "change" }],
				adminSecretKey: [{ required: true, message: "A secret key is required", trigger: "change" }],
				organisationAdminEmail: [{ validator: validateEmail, trigger: "change" }],
			},
		};
	},
	beforeMount() {
		$this = this;
	},
	watch: {
		enableUsageStrategy(val) {
			if (!val) {
				this.createOrganisationForm.usageStrategy = null;
			} else {
				this.createOrganisationForm.usageStrategy = "executions";
			}
		},
	},
	methods: {
		createOrg() {
			this.creationError = false;
			this.creationSuccess = false;
			this.formRules.organisationName.length === 2 ? this.formRules.organisationName.splice(1, 1) : null;
			this.$refs.form.validate(async (valid) => {
				if (valid) {
					this.operationInProgress = true;
					const result = await httpHelper(
						"RUNTIME",
						"POST",
						"security/createOrganisation",
						this.createOrganisationForm
					);
					setTimeout(() => {
						this.operationInProgress = false;
						if (!result?.error) {
							this.creationSuccess = true;
							this.creationError = false;

							setTimeout(() => {
								this.$router.push("/login");
							}, 500);
						} else {
							this.creationSuccess = false;
							if (result.status === 409) {
								this.formRules.organisationName.push({
									validator: (rule, value, callback) => {
										return callback(new Error("Organisation name already in use"));
									},
									trigger: "manual",
								});
								this.$refs.form.validate();
							} else if (result.status === 401) {
								this.errorMessage = "Secret key is not valid";
								this.creationError = true;
							} else {
								this.errorMessage = "An unknown error occurred";
								this.creationError = true;
							}
						}
					}, 500);
				} else {
					return;
				}
			});
		},
	},
};
</script>

<style scoped>
.pageWrapper {
	height: 100vh;
	width: 100vw;
	text-align: left;
}

.panel {
	height: 100vh;
	width: 100%;
}

.logo {
	height: 40px;
	margin-left: 20px;
	margin-top: 20px;
}

.actionPanel {
	background-color: white;
}

.contentPanel {
	background-color: #f5f7f9;
}

.createOrganisationForm {
	width: 70%;
	max-width: 400px;
	display: block;
	margin: auto;
	margin-top: 15%;
}

.underline {
	height: 8px;
	position: absolute;
	top: 35px;
	left: 0px;
}
</style>
